import { type Role } from '@hcc/types';

export interface AdminUser {
  id: string;
  email: string;
  display_name: string;
  roles: string[];
  person_id: string | null;
  has_password: boolean;
  disabled: boolean;
  disabled_at: string | null;
  disabled_reason: string | null;
  created_at: string;
  mobilisation_ids: string[];
}

export interface PersonLite {
  id: string;
  full_name: string;
  email: string;
}

export const ROLE_GROUPS: {
  title: string;
  options: { value: Role; label: string; description?: string }[];
}[] = [
  {
    title: 'On the day',
    options: [
      { value: 'reception', label: 'Reception', description: 'Check-in, arrivals list' },
      { value: 'station_it', label: 'Station — IT' },
      { value: 'station_ppe', label: 'Station — PPE / Uniform' },
      { value: 'station_tools', label: 'Station — Tools' },
      { value: 'station_fleet', label: 'Station — Fleet' },
      // station_dbshr intentionally omitted while DBSHR is hidden
      // from the UI; restore here if VISIBLE_STATIONS adds it back.
    ],
  },
  {
    title: 'Operations',
    options: [
      { value: 'coordinator', label: 'Coordinator', description: 'Global view, flags, reports' },
      { value: 'hr', label: 'HR', description: 'DBS, right-to-work, pre-employment checklist' },
      { value: 'manager', label: 'Manager', description: 'Reports of own team (Phase 2+)' },
    ],
  },
  {
    title: 'System',
    options: [
      { value: 'admin', label: 'Admin', description: 'Tenant config, role assignment' },
      {
        value: 'super_admin',
        label: 'Super admin',
        description: 'Multi-mobilisation + audit access',
      },
    ],
  },
  {
    title: 'Self-service',
    options: [
      { value: 'inductee', label: 'Inductee', description: 'Own data only' },
      {
        value: 'learner',
        label: 'Learner',
        description:
          'Own training only (training portal). Granted automatically on training-portal sign-in.',
      },
    ],
  },
];

const ROLE_LABEL: Record<string, string> = Object.fromEntries(
  ROLE_GROUPS.flatMap((g) => g.options.map((o) => [o.value, o.label])),
);

export function roleLabel(value: string): string {
  return ROLE_LABEL[value] ?? value;
}

export function sameSet(a: readonly string[], b: readonly string[]): boolean {
  if (a.length !== b.length) return false;
  const set = new Set(a);
  return b.every((x) => set.has(x));
}
